// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-icon{display:inline-block;vertical-align:middle;line-height:0}.lc-am-icon .yxt-icon,.lc-am-icon svg{vertical-align:middle;width:1em;height:1em;font-size:inherit;color:inherit}", ""]);
// Exports
module.exports = exports;
